import React from "react";
import { graphql } from "gatsby";
import { MdOutlineExplore, MdOutlineMap, MdOutlineSell } from "react-icons/md";

import { getBidSummary, getParcelSummary, getBidText } from "../helpers/sale";

const SaleSummary: React.FC<{
  sale: Queries.SaleSummarySaleFragment;
  className?: string;
}> = ({ sale, className = "" }) => {
  return (
    <div
      className={`mb-3 xl:mb-4 xl:flex xl:items-stretch xl:justify-between xl:gap-2 xl:pr-8 ${className}`}
    >
      {[
        {
          title: "Location",
          value: sale.location,
          icon: MdOutlineExplore,
          testId: "sale-location",
        },
        {
          title: "Sale Size",
          value: getParcelSummary(sale),
          icon: MdOutlineMap,
          testId: "sale-size",
        },
        {
          title: getBidText(sale, true, true),
          value: getBidSummary(sale),
          icon: MdOutlineSell,
          testId: "sale-bid",
        },
      ].map(({ value, title, icon: Icon, testId }, index) => (
        <React.Fragment key={title}>
          {index > 0 && (
            <span className="hidden w-[1px] bg-gray-500 xl:block" />
          )}
          <div className="flex items-center xl:block">
            <div className="flex items-center">
              <Icon className="mr-1 h-5 w-5 text-clhbid-orange" />
              <h6 className="min-w-[120px] text-clhbid-silver xl:min-w-0 xl:text-sm xl:italic">
                {title}
              </h6>
            </div>
            <h5
              className="text-lg font-bold text-white xl:ml-[4px] xl:text-base"
              data-testid={testId}
            >
              {value}
            </h5>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export const SaleSummaryFragment = graphql`
  fragment SaleSummarySale on ContentfulSale {
    location
    saleStatus
    parcels {
      size
      enBloc
      acceptedBid
      startingBid
    }
  }
`;

export default SaleSummary;
